import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// 1. Ant Design
import { Table, Tag, Typography } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
// 5. Types, utils, styles
import { LEDGER_ENTRY_TYPE_COLORS, LEDGER_ENTRY_TYPE_LABELS } from "@/types/company/settlements.common";
import { formatDateTime, formatMoney } from "./format";
import styles from "@/styles/Company/Settlements.module.less";
const { Text } = Typography;
const scrollToEntry = (entryId) => (event) => {
    event.preventDefault();
    document.getElementById(`ledger-${entryId}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
};
/** Леджер — только чтение (UC1120 §2.4, `v_corp_ledger`); REVERSAL отдельной строкой, автор `created_by_kind`/«—». */
const LedgerTable = observer(({ entries, loading }) => {
    const columns = [
        {
            title: "Момент",
            key: "effectiveAt",
            render: (_, entry) => formatDateTime(entry.effectiveAt),
        },
        {
            title: "Тип",
            key: "entryType",
            render: (_, entry) => (_jsx(Tag, { color: LEDGER_ENTRY_TYPE_COLORS[entry.entryType], children: LEDGER_ENTRY_TYPE_LABELS[entry.entryType] })),
        },
        {
            title: "Класс",
            key: "entryClass",
            render: (_, entry) => entry.entryClass,
        },
        {
            title: "Описание",
            key: "description",
            render: (_, entry) => (_jsxs(_Fragment, { children: [entry.description ?? _jsx(Text, { type: "secondary", children: "\u2014" }), entry.orderNumber ? _jsxs(Text, { type: "secondary", children: [" \u00B7 \u0437\u0430\u043A\u0430\u0437 ", entry.orderNumber] }) : null, entry.invoiceNumber ? _jsxs(Text, { type: "secondary", children: [" \u00B7 \u0441\u0447\u0451\u0442 ", entry.invoiceNumber] }) : null] })),
        },
        {
            title: "Сумма ₽",
            key: "amount",
            render: (_, entry) => (_jsx("span", { className: entry.amount < 0 ? styles.negative : undefined, children: formatMoney(entry.amount) })),
        },
        {
            title: "Автор",
            key: "createdByKind",
            render: (_, entry) => entry.createdByKind ?? _jsx(Text, { type: "secondary", children: "\u2014" }),
        },
        {
            title: "Сторно",
            key: "reversesEntryId",
            render: (_, entry) => entry.reversesEntryId ? (_jsxs("a", { href: `#ledger-${entry.reversesEntryId}`, onClick: scrollToEntry(entry.reversesEntryId), children: ["\u0441\u0442\u043E\u0440\u043D\u043E \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0438 \u2026", entry.reversesEntryId.slice(0, 8)] })) : (_jsx(Text, { type: "secondary", children: "\u2014" })),
        },
    ];
    return (_jsx("div", { "data-testid": "corp-settlements-ledger-table", children: _jsx(Table, { rowKey: "entryId", size: "middle", columns: columns, dataSource: entries, loading: loading, pagination: entries.length > 20 ? { pageSize: 20 } : false, scroll: { x: 1200 }, onRow: (entry) => ({ id: `ledger-${entry.entryId}` }), locale: { emptyText: "Проводок пока нет" } }) }));
});
LedgerTable.displayName = "LedgerTable";
export default LedgerTable;
